<script>
  import { CuratedByPageForm } from '@button/ui';
  import Layout from '../components/Layout.svelte';
  import { client } from '../lib/client';
  import { createQuery } from '@tanstack/svelte-query';
  import { TOAST_SUCCESS, TOAST_ERROR } from '../constants';
  import { addToast } from '../store';

  function getPageIdFromUrl() {
    const params = new URLSearchParams(window.location.search);
    const pageId = params.get('page');
    return pageId;
  }

  const pageId = getPageIdFromUrl();

  async function getPageQuery(pageId) {
    const page = await client.get(`/api/curated/page/${pageId}`);
    return page.data;
  }

  $: pageQuery = createQuery({
    queryKey: ['get-page-curated-query', pageId],
    queryFn: () => getPageQuery(pageId),
  });

  const successToast = (message) => {
    addToast({
      message,
      type: TOAST_SUCCESS,
    });
  };

  const errorToast = (message) => {
    addToast({
      message,
      type: TOAST_ERROR,
    });
  };
</script>

{#if $pageQuery.isSuccess}
  {@const pageData = $pageQuery?.data?.object}
  {@const [userHandle, destination] = pageData.path.split('/')}
  <Layout>
    <CuratedByPageForm
      editMode
      {successToast}
      {errorToast}
      initialUserHandle={userHandle}
      {destination}
      pageData={$pageQuery.data.object}
      socialHandle={pageData.configuration.socialHandle}
      bioLine1={pageData.configuration.bioLine1}
      bioLine2={pageData.configuration.bioLine2}
      selectedImage={pageData.configuration.image_url}
      linkType={pageData.configuration.categories}
      trackingIds={pageData?.configuration?.trackingIds.length > 0
        ? pageData.configuration.trackingIds.split(',')
        : []}
      storeIds={pageData?.configuration?.storeIds.length > 0
        ? pageData.configuration.storeIds.split(',')
        : []}
    />
  </Layout>
{/if}
